import styled from 'styled-components';
import { computeNetScore } from '../../../../../../common/model/output/scores/compute-net-score';
import { FinalImpactScoreType } from '../../../../../../common/model/output/scores/types';
import { TableColumn } from '../../../../../common/generic/content/tables/sortable-table';
import { formatNetImpactRatio } from '../../../../../common/generic/utilities/format';
import { ImpactChartDataSeries } from '../../../../../common/upright/model/output/scores/net-impact-chart/types';
import { defaultComparator, toExportValue } from '../../../../../common/upright/model/output/tables/columns/shared';
import { NumberCell } from '../../../../../common/upright/model/output/tables/table-styles';

export function getRenderLegendNetScoreColumn(data: ImpactChartDataSeries[], showAbsScores: boolean | undefined) {
  const scoreType = showAbsScores ? FinalImpactScoreType.ABSOLUTE : FinalImpactScoreType.RELATIVE;

  function getCellValue(datum: ImpactChartDataSeries) {
    const scores = datum.impactScoresByTIVV?.[scoreType];
    return scores ? computeNetScore(scores, scoreType) : undefined;
  }

  const title = 'Net impact ratio';

  const ret: TableColumn<ImpactChartDataSeries> = {
    key: 'netImpactRatio',
    title: <TitleCellContent>{title}</TitleCellContent>,
    titleAlign: 'right',
    values: data,
    comparator: (a, b, order) => defaultComparator(getCellValue(a), getCellValue(b), order),
    renderCell: (datum, index) => {
      const score = getCellValue(datum);
      return (
        <NumberCell style={{ width: 50 }} key={index}>
          {score !== undefined ? formatNetImpactRatio(score) : <></>}
        </NumberCell>
      );
    },
    renderExportValue: datum => toExportValue(getCellValue(datum)),
  };
  return ret;
}

const TitleCellContent = styled.div`
  white-space: nowrap;
  direction: rtl;
  width: 50px;
`;
